export type AppPlatform = "ios" | "android" | string;
export type TargetType = "workforce" | "user" | string;

export interface AppVersionItem {
  targetType: TargetType;
  uid: string;
  name: string;
  email: string | null;
  companyId: number;
  companyName: string;
  appVersion: string;
  appPlatform: AppPlatform;
  appVersionUpdatedAt: string;
  isSupported: boolean;
  isUpToDate: boolean;
}

export interface AppVersionSummary {
  appVersion: string;
  count: number;
}

export interface AppVersionCounts {
  workforces: number;
  users: number;
  outdated: number;
  unsupported: number;
}

export interface InstalledAppVersionsData {
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
  counts: AppVersionCounts;
  summaryByVersion: AppVersionSummary[];
  items: AppVersionItem[];
}

export interface InstalledAppVersionsResponse {
  status: number;
  message: string;
  data: InstalledAppVersionsData;
}
